<div class="massive-upload-container">
  <div class="header">
    <button class="btn-back" (click)="goBack()">← Volver</button>
    <h1>Subida masiva de notas simples</h1>
  </div>
  
  <div class="content">
    <div class="description-box">
      <p>Con esta herramienta puedes subir notas simples a múltiples expedientes cargando un fichero CSV con la información necesaria</p>
    </div>
    
    <!-- Directory Selection -->
    <div class="form-section">
      <label class="form-label">Directorio de archivos</label>
      <div class="input-group">
        <input 
          type="text" 
          class="form-input" 
          [value]="directoryPath()" 
          readonly 
          placeholder="Selecciona un directorio..."
        />
        <button class="btn-browse" (click)="selectDirectory()">Examinar</button>
      </div>
    </div>

    <!-- CSV File Selection -->
    <div class="form-section">
      <label class="form-label">Archivo CSV</label>
      <div class="input-group">
        <input 
          type="text" 
          class="form-input" 
          [value]="csvFilePath()" 
          readonly 
          placeholder="Selecciona un archivo CSV..."
        />
        <button class="btn-browse" (click)="selectCsvFile()">Examinar</button>
        <button class="btn-download" (click)="downloadExampleCsv()" title="Descargar CSV de ejemplo">
          ⬇ Ejemplo
        </button>
      </div>
    </div>

    <!-- Error Message -->
    @if (errorMessage()) {
      <div class="error-box">
        <strong>Error:</strong> {{ errorMessage() }}
      </div>
    }

    <!-- Data Table -->
    @if (isValidCsv() && csvData().length > 0) {
      <div class="table-section">
        <h3 class="table-title">Vista previa de datos ({{ csvData().length }} registros)</h3>
        <div class="table-container" (scroll)="onTableScroll($event)">
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>N° Expediente</th>
                <th>Nombre</th>
                <th>Fecha Emisión</th>
                @if (isUploading() || uploadFinished()) {
                  <th>Estado</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of displayedRows(); track row.ID) {
                <tr>
                  <td>{{ row.ID }}</td>
                  <td>{{ row.N_EXPEDIENTE }}</td>
                  <td>{{ row.NOMBRE }}</td>
                  <td>{{ row.FECHA_EMISION }}</td>
                  @if (isUploading() || uploadFinished()) {
                    <td [class]="'status-' + (row.ESTADO || 'PENDIENTE').toLowerCase()">
                      {{ row.ESTADO || 'PENDIENTE' }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        
        <div class="button-container">
          @if (!uploadFinished()) {
            @if (!isUploading()) {
              <button 
                class="btn-upload btn-start" 
                [disabled]="!canStartUpload()"
                (click)="startUpload()">
                Comenzar subida
              </button>
            } @else {
              <button 
                class="btn-upload btn-stop" 
                (click)="stopUpload()">
                Detener subida
              </button>
            }
          } @else {
            <button 
              class="btn-download-result btn-errors" 
              (click)="downloadErrorsCsv()">
              Descargar errores
            </button>
            <button 
              class="btn-download-result btn-success" 
              (click)="downloadSuccessCsv()">
              Descargar exitosos
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
